// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__6AmHN","addWidgetButton":"Header_addWidgetButton__1Otcj","dashboardTabs":"Header_dashboardTabs__3t1r3","active":"Header_active__3w86_"};